export default __webpack_public_path__ + "static/media/motivation_img.a3719859.png";